import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { usePromiseTracker } from 'react-promise-tracker';
import Loader from 'react-promise-loader';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { JWT_TOKEN, ROLE_ADMIN } from '../../constants/Config';
import PeopleIcon from '@material-ui/icons/People';
import DescriptionIcon from '@material-ui/icons/Description';
import CategoryIcon from '@material-ui/icons/Category';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        height: 'calc(100% - 2.5rem)',
    },
    drawerContainer: {
        overflow: 'auto',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
});

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

class CustomSideMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            indents: [],
            value: [<Typography paragraph>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                ut labore et dolore magna aliqua. Rhoncus dolor purus non enim praesent elementum
                facilisis leo vel. Risus at ultrices mi tempus imperdiet. Semper risus in hendrerit
                gravida rutrum quisque non tellus. Convallis convallis tellus id interdum velit laoreet id
                donec ultrices. Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
                adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra nibh cras.
                Metus vulputate eu scelerisque felis imperdiet proin fermentum leo. Mauris commodo quis
                imperdiet massa tincidunt. Cras tincidunt lobortis feugiat vivamus at augue. At augue eget
                arcu dictum varius duis at consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem
                donec massa sapien faucibus et molestie ac.
              </Typography>]
        };
    }

    generate(indents, value) {
        for (var i = 0; i < 1; i++) {
            indents.push(<span key={i}>{value}</span>);
        }
        return indents;
    }

    onUsersClick = () => {
        this.props.history.push("/users")
    }

    onLicensesClick = () => {
        this.props.history.push("/licenses")
    }

    onProductsClick = () => {
        this.props.history.push("/products")
    }

    render() {
        const { classes } = this.props;
        return (
            <div className="root">
                {
                    sessionStorage.getItem(JWT_TOKEN) &&
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <Toolbar />
                        <div className={classes.drawerContainer}>
                                <List>
                                {
                                    this.props.user.role === ROLE_ADMIN &&
                                    <ListItemLink onClick={this.onUsersClick}>
                                        <ListItemIcon>
                                            <PeopleIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Users" />
                                    </ListItemLink>
                                }
                                    <ListItemLink onClick={this.onLicensesClick}>
                                        <ListItemIcon>
                                            <DescriptionIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Licenses" />
                                    </ListItemLink>
                                {
                                    this.props.user.role === ROLE_ADMIN &&
                                    <ListItemLink onClick={this.onProductsClick}>
                                        <ListItemIcon>
                                            <CategoryIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Products" />
                                    </ListItemLink>
                                }
                                </List>
                            <Divider />
                        </div>
                    </Drawer>
                }
                {
                    sessionStorage.getItem(JWT_TOKEN) &&
                    <main className={classes.content}>
                        <Toolbar />
                        {this.props.sendView}
                        <Loader promiseTracker={usePromiseTracker} color={'#3d5e61'} background={'rgba(255,255,255,.5)'} />
                    </main>
                }
            </div>
        );
    }
}

CustomSideMenu.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
    };
};

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomSideMenu)));
